import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CtbConfService, PageBusquedaObject, CtbConfEmp, GralEmp, CtbCtaDefault } from '../ctb-conf.service';
import Swal from 'sweetalert2';
import { LoginService } from '../../../login/login.service';
import { DatePipe } from '@angular/common';
import { PeriodoEjercicioService } from '../../../control/periodo.service';
@Component({
  selector: 'app-formulario-ctb-conf',
  templateUrl: './formulario-ctb-conf.component.html',
  styleUrls: ['./formulario-ctb-conf.component.css'],
  providers: [DatePipe]
})
export class FormularioCtbConfComponent implements OnInit {
  catalogosPreinstalados: CtbCtaDefault[] = [];
  public id_param: number;
  public ejercicios: any[] = [];
  public ejercicio: number;
  public periodo: number;
  public dto: CtbConfEmp = new CtbConfEmp();
  busqueda: PageBusquedaObject = new PageBusquedaObject();
  items: GralEmp[];
  errors: String[];
  cargado: boolean;
  tipo_cierre: any;
  constructor(private router: Router, private service: CtbConfService,
    public loginService: LoginService, private activatedRoute: ActivatedRoute, public datepipe: DatePipe, private PeriodoEjercicioService: PeriodoEjercicioService) { }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ngOnInit() {
    this.PeriodoEjercicioService.ejercicio$.subscribe(ejercicio => {
      this.ejercicio = ejercicio ? ejercicio : 0;

    });
    this.PeriodoEjercicioService.periodo$
      .subscribe(periodo => {

        this.periodo = periodo ? periodo : 0;
      });
    this.cargarEjercicioActual();
    this.cargado = true;
    this.dto.emp = new GralEmp();
    this.cargarCatalogosPreinstalados();
    this.busqueda.criteriaSearch = {};
    this.activatedRoute.params.subscribe(params => {
      this.id_param = params['id'];
      if (this.id_param) {
        this.mostrarMensajeCarga();
        this.service.getCta(this.id_param).subscribe(response => {
          this.dto = response.contenido;
          this.tipo_cierre = this.dto.tipo_cierre;
          console.log(response);
          if (this.dto.emp) {
            this.busqueda.criteriaSearch['id'] = this.dto.emp.id;
            this.buscar();
            this.busqueda.criteriaSearch = {};
          }
          this.dto.catalogo = null;
          this.dto.periodo_vigente = this.periodo;
          this.dto.fecha_inicio = this.ejercicio + '-01-01';
          this.inicioDelEjercicio();
          this.delAl();
          this.cerrarMensajeCarga();
        }, err => {
          this.cerrarMensajeCarga();
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          })
          console.log(err);
        });
      } else {
        this.dto.emp = new GralEmp();
        this.dto.emp.titulo = '';
        this.dto.emp.rfc = '';
        this.dto.emp.nombre_comercial = '';
        this.dto.periodo = 1;
        this.buscar();
        this.setEjercicioActual(new Date().getFullYear());
      }
    });
  }
  asignarCatalogo(titulo: String) {
    this.service.getMonByEmpId(this.dto.emp.id).subscribe(response => {
      if (!response.contenido || response.contenido.length == 0) {
        Swal.fire({
          title: 'Error',
          text: `No existen monedas registradas`,
          allowOutsideClick: false,
          confirmButtonText: 'Aceptar'
        }).then((result) => {
          if (result.value) {
          }
        });
      } else {
        this.dto.catalogo = titulo;
      }
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  cargarEjercicioActual() {
    for (let x = 0; x < 3; x++) {
      this.ejercicios.push(new Date().getFullYear() + x);
    }
  }
  setEjercicioActual(anio: number) {
    this.dto.fecha_inicio = (anio + '-01-01');
    this.inicioDelEjercicio();

  }
  ValidaSoloNumeros() {
    var e = e || window.event;
    if ((e.keyCode < 46) || (e.keyCode > 57)) {
      e.returnValue = false;
      e.preventDefault();
    }
  }
  periodosEjercicio(periodos: number) {
    console.log(periodos)
    switch (+periodos) {
      case 1:
        // Mensual
        this.dto.numero_periodos = 12;
        break;
      case 2:
        // Bimestral
        this.dto.numero_periodos = 6;
        break;
      case 3:
        // Trimestral
        this.dto.numero_periodos = 4;
        break;
      case 4:
        // Semestral
        this.dto.numero_periodos = 2;
        break;
    }
    if (this.dto.periodo_vigente > this.dto.numero_periodos) {
      this.dto.periodo_vigente = this.dto.numero_periodos;
    }
  }
  delAl() {
    if (this.dto.periodo_vigente < 13) {
      const fechadelAl = new Date(this.dto.fecha_inicio + 'T00:00:00');
      fechadelAl.setMonth(fechadelAl.getMonth() + ((((this.dto.periodo_vigente - 1) * 12) / (this.dto.numero_periodos))));
      this.dto.del = this.datepipe.transform(fechadelAl, 'yyyy-MM-dd');
      fechadelAl.setMonth(fechadelAl.getMonth() + (12 / this.dto.numero_periodos));
      fechadelAl.setDate(fechadelAl.getDate() - 1);
      this.dto.al = this.datepipe.transform(fechadelAl, 'yyyy-MM-dd');
    } else {
      const fechadelAl = new Date(this.dto.fecha_inicio + 'T00:00:00');
      fechadelAl.setMonth(fechadelAl.getMonth() + ((((this.dto.periodo_vigente - 2) * 12) / (this.dto.numero_periodos))));
      fechadelAl.setMonth(fechadelAl.getMonth() + (12 / this.dto.numero_periodos));
      fechadelAl.setDate(fechadelAl.getDate() - 1);
      this.dto.del = this.datepipe.transform(fechadelAl, 'yyyy-MM-dd');
      this.dto.al = this.datepipe.transform(fechadelAl, 'yyyy-MM-dd');
    }
  }
  asignarEmpresa(campo: String) {
    switch (campo) {
      case 'titulo':
        this.busqueda.criteriaSearch['titulo'] = this.dto.emp.titulo;
        this.busqueda.criteriaSearch['rfc'] = '';
        break;
      case 'rfc':
        this.busqueda.criteriaSearch['titulo'] = '';
        this.busqueda.criteriaSearch['rfc'] = this.dto.emp.rfc;
        break;
    }
    this.service.find(this.busqueda).subscribe(response => {
      this.items = response.contenido;
      if (this.items != null && this.items.length === 1) {
        switch (campo) {
          case 'titulo':
            if (this.busqueda.criteriaSearch['titulo'] === this.items[0].titulo) {
              this.dto.emp = this.items[0];
            } else {
              this.dto.emp.id = undefined;
            }
            break;
          case 'rfc':
            if (this.busqueda.criteriaSearch['rfc'] === this.items[0].rfc) {
              this.dto.emp = this.items[0];
            } else {
              this.dto.emp.id = undefined;
            }
            break;
        }
      }
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire('TNK Ledger', err.error.mensaje, 'error');;
    });
  }
  inicioDelEjercicio() {
    const fechaInicioEjercicio = new Date(this.dto.fecha_inicio);
    fechaInicioEjercicio.setFullYear(fechaInicioEjercicio.getFullYear() + 1);
    console.log(fechaInicioEjercicio);
    this.dto.fecha_fin = this.datepipe.transform(fechaInicioEjercicio, 'yyyy-MM-dd');
    this.delAl();
  }
  previewEstructura() {
    let estructura1 = '';
    const estructuras = this.dto.estructura.split('-');
    for (let x = 0; x < estructuras.length; x++) {
      for (let y = 0; y < Number(estructuras[x]); y++) {
        estructura1 = estructura1 + 'X';
      }
      if (x !== estructuras.length - 1) {
        estructura1 = estructura1 + '-';
      }
    }
    this.dto.estructura1 = estructura1;
  }
  buscar() {
    this.service.find(this.busqueda).subscribe(response => {
      this.items = response.contenido;
      console.log(response);
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire('TNK Ledger', err.error.mensaje, 'error');
      console.log(err.error.mensaje);
    });
  }
  crear() {
    this.dto.gralUsrCreaId = this.loginService.usuario.id as number;
    this.dto.gralUsrActualizaId = this.loginService.usuario.id as number;
    this.dto.gralUsrBajaId = this.loginService.usuario.id as number;
    this.service.post(this.dto).subscribe(response => {
      Swal.fire(response.mensaje);
      this.router.navigate(['/contabilidad/catalogo/ctb-conf']);
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      this.errors = err.error.error;
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
    });
  }
  actualizar() {
    this.dto.gralUsrActualizaId = this.loginService.usuario.id as number;
    this.service.put(this.dto).subscribe(response => {
      if (response.exitoso == false) {
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: response.mensaje
        })
      } else {
        if (this.dto.tipo_cierre != this.tipo_cierre) {
          Swal.fire({
            title: 'TNK Ledger',
            text: `Se ha detectado un cambio con la configuración de cierre, es necesario que refresque la pagina en todos los navegadores que usan el sistema en este momento`,
            showCancelButton: false,
            confirmButtonText: 'Aceptar'
          }).then((result) => {
            if (result.value) {
              this.router.navigate(['/contabilidad/catalogo/ctb-conf']);
            }
          });
        } else {
          this.router.navigate(['/contabilidad/catalogo/ctb-conf']);
        }
      }
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      this.errors = err.error.error;
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
    });
  }
  cargarCatalogosPreinstalados() {
    this.service.getCatalogoPreinstalado().subscribe(response => {
      this.catalogosPreinstalados = response.contenido;
      console.log(response)
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      this.errors = err.error.error;
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
    });
  }
  mostrarMensajeCarga() {
    this.cargado = false;
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Procesando...',
      showConfirmButton: false,
      timerProgressBar: true,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      }
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }
}
